import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fourfivebusonrentinsolapur() {



  const cardData =
  {
    keyword: '45 Seater Bus on Rent in Solapur',
    heading: 'Sanavi Travels: 45 Seater Bus on Rent in Solapur',
    headingDescription: 'Sanavi Travels offers 45 Seater Bus on Rent in Solapur, providing safe, comfortable, and spacious transportation for large groups, corporate trips, school excursions, weddings, family outings, and outstation travel. Our fleet of well-maintained 45-seater AC and Non-AC buses ensures smooth rides, ample seating, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, renting a 45-seater bus in Solapur is perfect for local travel, sightseeing tours, group outings, and long-distance trips. Choose Sanavi Travels for trusted 45-seater bus rental services in Solapur, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Solapur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Solapur City",
    "description": "Solapur is a historic city in Maharashtra, known for its rich textile industry, vibrant culture, and religious significance. The city is a blend of Maratha, Deccan, and Varkari traditions, offering a mix of historical sites, bustling markets, and spiritual destinations. Solapur is famous for its Chaddars, Solapuri Phetas, and traditional cuisine, making it an interesting destination for both culture enthusiasts and travelers."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "The Siddheshwar Temple is Solapur’s most revered shrine, dedicated to Lord Siddheshwar, an incarnation of Lord Shiva. The temple complex includes a pond, a large courtyard, and smaller shrines. The annual fair attracts thousands of devotees, offering a vibrant display of devotion, rituals, and local traditions."
  },
  {
    "title": "Solapur Fort",
    "description": "Solapur Fort is a historic structure built during the Adil Shahi and later Maratha periods. It features massive stone walls, bastions, and gates that reflect medieval military architecture. The fort area offers a glimpse into the city’s historical significance and strategic importance in the Deccan region."
  },
  {
    "title": "Akkalkot Swami Samarth Temple",
    "description": "Located near Solapur, the Akkalkot Swami Samarth Temple is dedicated to the 19th-century saint Swami Samarth Maharaj. Pilgrims visit in large numbers seeking blessings, spiritual guidance, and fulfillment of wishes. The temple complex includes meditation halls, ashrams, and facilities for devotees."
  },
  {
    "title": "Great Indian Bustard Sanctuary (near Solapur)",
    "description": "The Great Indian Bustard Sanctuary is a wildlife conservation area near Solapur, dedicated to protecting the endangered Great Indian Bustard. Nature enthusiasts and wildlife photographers visit to observe rare species, migratory birds, and unique grassland ecosystems in the region."
  },
  {
    "title": "Bhuikot Fort and Heritage Sites",
    "description": "Apart from Solapur Fort, the city has smaller historical forts and heritage sites showcasing Maratha, Adil Shahi, and Nizam architectural influences. These sites provide insight into Solapur’s past and offer opportunities for photography and historical exploration."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "Solapur is famous for its textile markets, Chaddar weaving, and Solapuri Pheta turbans. Local bazaars offer traditional crafts, clothing, and regional delicacies, giving visitors a vibrant shopping experience and a glimpse into local livelihoods."
  },
  {
    "title": "Siddheshwar Lake and Gardens",
    "description": "The temple vicinity includes Siddheshwar Lake and landscaped gardens, providing a peaceful environment for morning walks, meditation, and relaxation. The combination of greenery, water, and spiritual ambiance makes it a serene spot within the bustling city."
  },
  {
    "title": "Religious and Cultural Festivals",
    "description": "Solapur hosts several religious and cultural festivals such as Maha Shivratri, Ganesh Chaturthi, and the Siddheshwar Jatra. These events feature processions, devotional music, folk dances, and community feasts, offering visitors an immersive cultural experience."
  },
  {
    "title": "Solapur’s Rural Surroundings",
    "description": "The areas around Solapur are primarily agricultural, with sugarcane, jowar, and pulses cultivated extensively. Visiting nearby villages allows travelers to experience rural life, traditional farming practices, and local hospitality, adding a serene escape to the city’s urban vibe."
  }
]
,



"services": [
{
"name": "45 Seater Bus on Rent in Solapur",
"description": "45 Seater Bus on Rent in Solapur provides spacious, comfortable, and well-maintained buses suitable for large groups, corporate outings, school trips, weddings, and religious tours. Equipped with modern amenities, professional drivers, and advanced safety features, it ensures a smooth, safe, and enjoyable journey. Ideal for long-distance travel, city tours, and event transportation, this bus combines reliability, convenience, and affordability for all types of group travel from Solapur."
},
{
"name": "45 Seater Bus Hire Solapur",
"description": "45 Seater Bus Hire Solapur offers flexible rental services for medium to large groups traveling for weddings, family trips, corporate events, or religious pilgrimages. With well-maintained buses, experienced chauffeurs, and punctual service, it guarantees stress-free, safe, and comfortable journeys tailored to travelers’ schedules and needs."
},
{
"name": "AC 45 Seater Bus Solapur",
"description": "AC 45 Seater Bus Solapur provides a cool and comfortable travel experience with air-conditioned interiors, spacious seating, and professional drivers. Perfect for families, groups, corporate clients, and tourists, it ensures a relaxed and enjoyable journey for both short and long-distance trips, enhancing passenger comfort throughout the ride."
},
{
"name": "Luxury Bus Solapur",
"description": "Luxury Bus Solapur offers premium travel with elegant interiors, comfortable seating, modern amenities, and well-trained drivers. Ideal for weddings, VIP tours, corporate events, and leisure trips, it provides a blend of style, comfort, and safety, ensuring a memorable and enjoyable journey for passengers."
},
{
"name": "Wedding Bus Solapur",
"description": "Wedding Bus Solapur provides reliable and spacious buses for weddings, pre-wedding events, and related functions. Professional drivers, comfortable seating, and timely service make it perfect for transporting guests, family members, and friends, ensuring stress-free, safe, and memorable wedding travel experiences."
},
{
"name": "Corporate Bus Solapur",
"description": "Corporate Bus Solapur caters to businesses needing reliable transportation for employees, team outings, meetings, and corporate events. With comfortable seating, professional chauffeurs, and organized schedules, it ensures efficient, safe, and stress-free travel for all corporate clients."
},
{
"name": "Outstation Bus Solapur",
"description": "Outstation Bus Solapur provides dependable long-distance travel services for families, groups, and corporate clients. Well-maintained buses, experienced drivers, and planned itineraries ensure safe, comfortable, and convenient journeys to nearby cities, tourist destinations, and religious sites from Solapur."
},
{
"name": "Affordable Bus Solapur",
"description": "Affordable Bus Solapur offers budget-friendly 45-seater bus rentals without compromising comfort, safety, or quality. Perfect for group trips, weddings, corporate outings, and family travel, it guarantees reliable transport, professional drivers, and smooth journeys at competitive rates for all passengers."
},
{
"name": "Chauffeur Driven Bus Solapur",
"description": "Chauffeur Driven Bus Solapur ensures a stress-free journey with professional drivers handling navigation, traffic, and schedules. Suitable for weddings, corporate trips, religious tours, and group travel, it provides safe, comfortable, and convenient travel experiences for all passengers."
},
{
"name": "Best 45 Seater Bus Solapur",
"description": "Best 45 Seater Bus Solapur offers top-quality, spacious buses with modern amenities and professional drivers. Ideal for corporate events, weddings, family trips, and group travel, it guarantees punctual, safe, and comfortable journeys for both local and outstation travel from Solapur."
},
{
"name": "Tourist Bus Solapur",
"description": "Tourist Bus Solapur caters to travelers exploring Solapur and nearby attractions. Spacious buses, experienced drivers, and organized itineraries provide a convenient, safe, and enjoyable travel experience for families, friends, and groups visiting temples, cultural landmarks, and tourist destinations."
},
{
"name": "Group Travel Bus Solapur",
"description": "Group Travel Bus Solapur offers organized transport solutions for medium to large groups, corporate teams, and family trips. With spacious buses, professional drivers, and reliable service, it ensures safe, smooth, and enjoyable group travel for social, religious, and corporate events from Solapur."
},
{
"name": "Online Bus Booking Solapur",
"description": "Online Bus Booking Solapur allows travelers to reserve 45-seater buses quickly and easily for local and outstation trips. With instant confirmation, multiple bus options, and flexible scheduling, it simplifies travel planning, providing a hassle-free booking experience for families, groups, and corporate clients."
},
{
"name": "Event Bus Solapur",
"description": "Event Bus Solapur provides dedicated bus services for weddings, corporate events, parties, and social gatherings. With spacious seating, professional drivers, and punctual service, it ensures organized, safe, and comfortable transportation for all attendees, making events more convenient and enjoyable."
},
{
"name": "Solapur Travel Bus",
"description": "Solapur Travel Bus delivers comprehensive travel solutions for sightseeing, outstation trips, weddings, corporate travel, family outings, and religious tours. With reliable buses, experienced drivers, and high-quality service, it ensures safe, comfortable, and convenient journeys for large groups, families, and corporate travelers in and around Solapur."
}
],
"tableData": [
["45 Seater Bus on Rent in Solapur", "45 Seater Bus Hire Solapur"],
["AC 45 Seater Bus Solapur", "Luxury Bus Solapur"],
["Wedding Bus Solapur", "Corporate Bus Solapur"],
["Outstation Bus Solapur", "Affordable Bus Solapur"],
["Chauffeur Driven Bus Solapur", "Best 45 Seater Bus Solapur"],
["Tourist Bus Solapur", "Group Travel Bus Solapur"],
["Online Bus Booking Solapur", "Event Bus Solapur"],
["Solapur Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "45 Seater Bus on Rent in Solapur with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable 45 seater bus rental services in Solapur, perfect for large group travel, school trips, corporate tours, family outings, and pilgrimages."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Bus",
    "WhyChoosedescription": "Our 45 seater buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Solapur and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Solapur routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for 45 seater bus rentals in Solapur, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your 45 seater bus hire."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from half‑day, full‑day, or customized rental plans based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicle",
    "WhyChoosedescription": "The 45 seater bus is thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 45 seater bus rentals in Solapur."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 45 seater bus rentals in Solapur?',
    answer: 'Yes, Sanavi Travels offers reliable 45 seater bus rental services in Solapur for various travel needs.'
  },
  {
    question: 'How can I book a 45 seater bus in Solapur?',
    answer: 'You can easily book a 45 seater bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What amenities are available in the 45 seater bus?',
    answer: 'Our 45 seater buses come with comfortable seating, air‑conditioning, ample space, and regular maintenance for a pleasant journey.'
  },
  {
    question: 'Are the drivers experienced with Solapur routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes in and around Solapur to ensure safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Yes, you can select your preferred pickup and drop‑off locations anywhere in Solapur and nearby areas.'
  },
  {
    question: 'Is the 45 seater bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock support to help you book your 45 seater bus in Solapur at any time.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are accepted for the 45 seater bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 45 seater bus trip in Solapur.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Yogesh Patil',
    feedback: 'Booked a 45 seater bus in Solapur with Sanavi Travels — very comfortable and smooth journey. Excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Radhika More',
    feedback: 'Sanavi Travels provided a reliable and clean 45 seater bus for our group travel in Solapur. Highly recommended!',
    rating: 5
  }
];



































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "45 Seater Bus on Rent in Solapur - Sanavi Travels",
  "description": "Rent a 45 seater bus in Solapur with Sanavi Travels. AC and luxury buses available for weddings, corporate trips, outstation tours, group travel, and events. Affordable chauffeur-driven buses with online booking.",
  "touristType": "Group Travel, Corporate Travel, Wedding, Outstation",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};





  return (
    <div>
<Helmet>
  <title>
    45 Seater Bus on Rent in Solapur | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 45 seater bus on rent in Solapur with Sanavi Travels. AC, luxury, and affordable chauffeur-driven buses for weddings, corporate trips, tourist tours, and group travel. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/160.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fourfivebusonrentinsolapur;